
let default_axis_options = {
  top: "0px",
}
class CBAxisPaint {
  constructor(options) {
    this.options = Object.deepAssign({}, default_axis_options, options)
  }

  destroy() {
    if (this.container) {
      this.container.innerHTML = ""
    }
  }

  set_container(container) {

    this.container = container
    this.container.style.display = "block"
    this.container.style.position = "relative"
    return this
  }

  draw(scale, dataset) {
    if (scale) {
      let tick_values = this.options.tick_values
      if (tick_values) {
        tick_values = this.format_tick_value(tick_values)
      }
      else {
        // 這個好像沒寫好 不要用
        // if (dataset) {
        //   tick_values = this.range_tick_values(dataset)
        // }
        // else {
        //   tick_values = this.format_tick_value(scale.value_list(this.options.tick_interval))
        // }
        tick_values = this.format_tick_value(scale.value_list(this.options.tick_interval, this.options.number_of_ticks))
      }

      for (let idx in tick_values) {
        let tick_value = tick_values[idx]
        let text_div = document.createElement('div')
        text_div.style.position = 'absolute'

        this.place_tick_value(text_div, css_unit_join(scale.position(tick_value.value)))

        if (this.options.font_size) {
            text_div.style.fontSize = css_unit_join(this.options.font_size)
        }
        text_div.style.zIndex = 1
        text_div.innerHTML = tick_value.text

        this.container.appendChild(text_div)
      }
    }
    return this
  }

  format_tick_value(data_list, tick_interval) {
    let format = (v) => { return v }
    if (this.options.tick_value_format) {
      format = this.options.tick_value_format
    }
    if (!tick_interval) {
      tick_interval = 1
    }
    let tick_values = []
    for (let idx=0; idx<data_list.length; idx += tick_interval) {
      tick_values.push({
        value: data_list[idx],
        text: format(data_list[idx])
      })
    }
    return tick_values
  }

  range_tick_values(dataset) {
    console.error("Not Implemented")
    return this
  }
}


class CBAxisXPaint extends CBAxisPaint {
  range_tick_values(dataset) {
    return this.format_tick_value(dataset.xlist(), this.options.tick_interval)
  }

  place_tick_value(text_div, position) {
    text_div.style.left = position
    text_div.style.transform = this.get_trasform(this.options.tick_value_anchor)
  }

  get_trasform(anchor) {
    switch(anchor) {
      case 'right':
        return 'translateX(-100%)'
      case 'center':
        return 'translateX(-50%)'
      case 'left':
        return 'translateX(0%)'
    }
  }
}


class CBAxisYPaint extends CBAxisPaint {
  range_tick_values(dataset) {
    return this.format_tick_value(dataset.ylist(), this.options.tick_interval)
  }

  place_tick_value(text_div, position) {
    if (this.options.text_align === 'left') {
      text_div.style.left = '5px'
    }
    else if(this.options.text_align === 'right') {
      text_div.style.right = '5px'
    }
    text_div.style.top = position
    text_div.style.transform = this.get_trasform(this.options.tick_value_anchor)
  }

  get_trasform(anchor) {
    switch(anchor) {
      case 'top':
        return 'translateY(-100%)'
      case 'middle':
        return 'translateY(-50%)'
      case 'bottom':
        return 'translateY(0%)'
    }
  }
}


class CBDoubleAxisXPaint extends CBAxisXPaint {
  draw(scale) {
  }
}


export {
  CBAxisXPaint, CBAxisYPaint, CBDoubleAxisXPaint
}



// WEBPACK FOOTER //
// ./src/assets/cb/cb-chart/cb_axis_paint.js